.br-app-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0;
}

.br-app-alert__content {
  flex: 1;
  min-width: 0;
}

.br-app-alert__content a {
  margin-left: 1rem;
}

.br-app-alert__dismiss {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
}

.br-app-alert__dismiss:hover {
  background: var(--br-hover-surface);
}

.br-app-alert__dismiss:focus-visible {
  outline: 3px solid var(--br-focus);
  outline-offset: 2px;
}
